<div class="col-12">
  <div class="mb1 flex flex-column">
    @if (schema().title) {
      <h2 class="mat-body-2 name-heading m0">{{ schema().title }}</h2>
    }
    @if (schema().description) {
      <small class="small text-muted">{{ schema().description }}</small>
    }
  </div>

  <div cdkDropList (cdkDropListDropped)="dropName($event)">
    @for (nameControl of aFormControl().controls; track nameControl) {
      @let control = getNameControl($index);
      @let mode = getMode($index);

      @if (control) {
      <div class="name-item" [formGroup]="control" cdkDrag cdkDragLockAxis="y">
        <div class="name-drag">
          <button
            type="button"
            mat-icon-button
            cdkDragHandle
            [attr.aria-label]="'Reorder name ' + ($index + 1)"
            matTooltip="Reorder"
          >
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>

        <div class="flex-auto">
          @if (mode === 'person' && control.get('family') && control.get('given')) {
            <div class="person">
              <mat-form-field class="flex-auto" subscriptSizing="dynamic">
                <mat-label>Family Name</mat-label>
                <input matInput formControlName="family" placeholder="Last name" />
              </mat-form-field>

              <mat-form-field class="flex-auto" subscriptSizing="dynamic">
                <mat-label>Given Name</mat-label>
                <input matInput formControlName="given" placeholder="First name" />
              </mat-form-field>
            </div>
          }

          @if (mode === 'literal' && control.get('literal')) {
            <mat-form-field class="col-12" subscriptSizing="dynamic">
              <mat-label>Name</mat-label>
              <input matInput formControlName="literal" placeholder="Full name or organization" />
            </mat-form-field>
          }
        </div>

        <mat-button-toggle-group
          [value]="mode"
          (change)="switchMode($index, $event.value)"
          aria-label="Name type"
        >
          <mat-button-toggle value="person">Person</mat-button-toggle>
          <mat-button-toggle value="literal">Organization</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="name-actions">
          <button
            type="button"
            mat-icon-button
            class="reorder-btn"
            (click)="moveNameUp($index)"
            [disabled]="$index === 0"
            matTooltip="Move up"
            aria-label="Move up"
          >
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            class="reorder-btn"
            (click)="moveNameDown($index)"
            [disabled]="$index === aFormControl().length - 1"
            matTooltip="Move down"
            aria-label="Move down"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>

          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="removeName($index)"
            matTooltip="Remove name"
            aria-label="Remove name"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      }
    }
  </div>

  <div class="mt2">
    <button type="button" mat-stroked-button (click)="addName()">
      <mat-icon>add</mat-icon>
      Add name
    </button>
  </div>
</div>
